import { render, staticRenderFns } from "./ViewInactiveAlert.vue?vue&type=template&id=2613e8de&scoped=true"
import script from "./ViewInactiveAlert.vue?vue&type=script&lang=js"
export * from "./ViewInactiveAlert.vue?vue&type=script&lang=js"
import style0 from "./ViewInactiveAlert.vue?vue&type=style&index=0&id=2613e8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613e8de",
  null
  
)

export default component.exports